<template>
  <div class="hello mt-3">
    <img alt="Logo UMSS" src="../assets/umss.png">
    <h1 class="mt-3">{{ msg }}</h1>
    <p>
      Bienvenido al Sistema de Transcripción de Notas de Bachillerato.
    </p>
    <h3>Acciones que puede realizar</h3>
    <ul class="mt-3">
      <li><a href="/login" class="btn btn-primary">Ingresar</a></li>
      <li><a href="/about" class="btn btn-primary ml-1">Acerca de</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Bienvenida',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: white;
  font-size: 20px;
  font-style: bold;
}
</style>
